import React from 'react';
import { BadgeCheck, CalendarX, Hash, Mail, User } from 'lucide-react';
import { Card, Field, FieldGrid } from './Card';

/** USA Lacrosse membership. CamperDetail renders it only when a membership id exists, as before. */
const UsalCard = ({ entity }) => (
    <Card id="usal" title="USAL Customer Information" icon={BadgeCheck}>
        <FieldGrid className="tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-3 lg:tw-grid-cols-3">
            <Field icon={User} label="First name">{entity?.firstname}</Field>
            <Field icon={User} label="Last name">{entity?.lastname}</Field>
            <Field icon={Hash} label="USAL member ID">{entity?.membership_id}</Field>
            <Field icon={CalendarX} label="Expiration date">{entity?.exp_date}</Field>
            <Field icon={Mail} label="Email" placeholder="Not found">{entity?.email}</Field>
        </FieldGrid>
    </Card>
);

export default UsalCard;
